/**
 * サイト設定のうち公開サイトが使う項目と、その既定値。
 * 既定値は db/src/siteSettings.ts の SITE_SETTING_DEFS と同じにする (フロントから @bml/db は import しない)。
 * 実際の値は GET /api/site から取得し、取得前・失敗時はこの既定値で描画する。
 */
export interface SiteLinks {
  mail: string;
  x: string;
  youtube: string;
  faq: string;
  contact: string;
}

export interface SiteInfo {
  siteName: string;
  links: SiteLinks;
  copyright: string;
}

export const SITE_DEFAULTS: SiteInfo = {
  siteName: 'BML',
  links: {
    mail: '',
    x: '',
    youtube: 'https://www.youtube.com/@BuzzMusicLabel',
    faq: '',
    contact: '',
  },
  copyright: 'Copyright©2025 BML Inc.',
};
